import { Badge, type TenantStatus } from '@bixo/ui'
import { Loader2 } from 'lucide-react'

const STATUS_LABELS: Record<TenantStatus, string> = {
  provisioning: 'Provisioning',
  active: 'Active',
  suspended: 'Suspended',
  failed: 'Failed',
}

export function StatusBadge({ status }: { status: TenantStatus }) {
  switch (status) {
    case 'provisioning':
      return (
        <Badge variant="warning">
          <Loader2 className="animate-spin" /> {STATUS_LABELS[status]}
        </Badge>
      )
    case 'active':
      return (
        <Badge variant="success" dot>
          {STATUS_LABELS[status]}
        </Badge>
      )
    case 'suspended':
      return <Badge dot>{STATUS_LABELS[status]}</Badge>
    case 'failed':
      return (
        <Badge variant="danger" dot>
          {STATUS_LABELS[status]}
        </Badge>
      )
  }
}
